import { render, staticRenderFns } from "./Basic-1.vue?vue&type=template&id=8201470e&scoped=true&"
import script from "./Basic-1.vue?vue&type=script&lang=js&"
export * from "./Basic-1.vue?vue&type=script&lang=js&"
import style0 from "./Basic-1.vue?vue&type=style&index=0&id=8201470e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8201470e",
  null
  
)

export default component.exports